// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: layout,
    redirect: '/subscribe/index',
    meta: {
      title: '订阅',
      icon: 'i-menu:subscribe',
      i18Key: 'router.user.subscribe.title',
      roles: [1]
    },
    sort: 60,
    children: [
      {
        path: 'index',
        name: 'SubscribeIndex',
        component: () => import('@/views/Subscribe/Index.vue'),
        meta: {
          title: '订阅',
          icon: 'i-menu:subscribe',
          i18Key: 'router.user.subscribe.index',
          roles: [1]
        }
      }
    ]
  }
]
export default routes
